module.exports = __webpack_public_path__ + "img/zhyj-1.6da3edab.png";